import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { selectCurrentUserProfile } from '@libs/store';
import { ffdNotesRoutePrefix, routes } from '@libs/utils';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

export const signBaaGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectCurrentUserProfile).pipe(
    filter((profile) => profile != null),
    take(1),
    map((profile) => {
      if (!profile!.ffdNotesBaaSigned) {
        return router.createUrlTree([...ffdNotesRoutePrefix(), routes.ffdNotesSignBaa]);
      }
      if (!profile!.ffdNotesBaaActivated) {
        return router.createUrlTree([...ffdNotesRoutePrefix(), routes.ffdNotesActivate]);
      }
      return true;
    }),
  );
};
